/*!
 * KoliBri - The accessible HTML-Standard
 */
function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var loglevel$1 = {exports: {}};

/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/
var loglevel = loglevel$1.exports;

var hasRequiredLoglevel;

function requireLoglevel () {
	if (hasRequiredLoglevel) return loglevel$1.exports;
	hasRequiredLoglevel = 1;
	(function (module) {
		(function (root, definition) {
		    if (module.exports) {
		        module.exports = definition();
		    } else {
		        root.log = definition();
		    }
		}(loglevel, function () {

		    // Slightly dubious tricks to cut down minimized file size
		    var noop = function() {};
		    var undefinedType = "undefined";
		    var isIE = (typeof window !== undefinedType) && (typeof window.navigator !== undefinedType) && (
		        /Trident\/|MSIE /.test(window.navigator.userAgent)
		    );

		    var logMethods = [
		        "trace",
		        "debug",
		        "info",
		        "warn",
		        "error"
		    ];

		    var _loggersByName = {};
		    var defaultLogger = null;

		    // Cross-browser bind equivalent that works at least back to IE6
		    function bindMethod(obj, methodName) {
		        var method = obj[methodName];
		        if (typeof method.bind === 'function') {
		            return method.bind(obj);
		        } else {
		            try {
		                return Function.prototype.bind.call(method, obj);
		            } catch (e) {
		                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
		                return function() {
		                    return Function.prototype.apply.apply(method, [obj, arguments]);
		                };
		            }
		        }
		    }

		    // Trace() doesn't print the message in IE, so for that case we need to wrap it
		    function traceForIE() {
		        if (console.log) {
		            if (console.log.apply) {
		                console.log.apply(console, arguments);
		            } else {
		                // In old IE, native console methods themselves don't have apply().
		                Function.prototype.apply.apply(console.log, [console, arguments]);
		            }
		        }
		        if (console.trace) console.trace();
		    }

		    // Build the best logging method possible for this env
		    // Wherever possible we want to bind, not wrap, to preserve stack traces
		    function realMethod(methodName) {
		        if (methodName === 'debug') {
		            methodName = 'log';
		        }

		        if (typeof console === undefinedType) {
		            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
		        } else if (methodName === 'trace' && isIE) {
		            return traceForIE;
		        } else if (console[methodName] !== undefined) {
		            return bindMethod(console, methodName);
		        } else if (console.log !== undefined) {
		            return bindMethod(console, 'log');
		        } else {
		            return noop;
		        }
		    }

		    // These private functions always need `this` to be set properly

		    function replaceLoggingMethods() {
		        /*jshint validthis:true */
		        var level = this.getLevel();

		        // Replace the actual methods.
		        for (var i = 0; i < logMethods.length; i++) {
		            var methodName = logMethods[i];
		            this[methodName] = (i < level) ?
		                noop :
		                this.methodFactory(methodName, level, this.name);
		        }

		        // Define log.log as an alias for log.debug
		        this.log = this.debug;

		        // Return any important warnings.
		        if (typeof console === undefinedType && level < this.levels.SILENT) {
		            return "No console available for logging";
		        }
		    }

		    // In old IE versions, the console isn't present until you first open it.
		    // We build realMethod() replacements here that regenerate logging methods
		    function enableLoggingWhenConsoleArrives(methodName) {
		        return function () {
		            if (typeof console !== undefinedType) {
		                replaceLoggingMethods.call(this);
		                this[methodName].apply(this, arguments);
		            }
		        };
		    }

		    // By default, we use closely bound real methods wherever possible, and
		    // otherwise we wait for a console to appear, and then try again.
		    function defaultMethodFactory(methodName, _level, _loggerName) {
		        /*jshint validthis:true */
		        return realMethod(methodName) ||
		               enableLoggingWhenConsoleArrives.apply(this, arguments);
		    }

		    function Logger(name, factory) {
		      // Private instance variables.
		      var self = this;
		      /**
		       * The level inherited from a parent logger (or a global default). We
		       * cache this here rather than delegating to the parent so that it stays
		       * in sync with the actual logging methods that we have installed (the
		       * parent could change levels but we might not have rebuilt the loggers
		       * in this child yet).
		       * @type {number}
		       */
		      var inheritedLevel;
		      /**
		       * The default level for this logger, if any. If set, this overrides
		       * `inheritedLevel`.
		       * @type {number|null}
		       */
		      var defaultLevel;
		      /**
		       * A user-specific level for this logger. If set, this overrides
		       * `defaultLevel`.
		       * @type {number|null}
		       */
		      var userLevel;

		      var storageKey = "loglevel";
		      if (typeof name === "string") {
		        storageKey += ":" + name;
		      } else if (typeof name === "symbol") {
		        storageKey = undefined;
		      }

		      function persistLevelIfPossible(levelNum) {
		          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();

		          if (typeof window === undefinedType || !storageKey) return;

		          // Use localStorage if available
		          try {
		              window.localStorage[storageKey] = levelName;
		              return;
		          } catch (ignore) {}

		          // Use session cookie as fallback
		          try {
		              window.document.cookie =
		                encodeURIComponent(storageKey) + "=" + levelName + ";";
		          } catch (ignore) {}
		      }

		      function getPersistedLevel() {
		          var storedLevel;

		          if (typeof window === undefinedType || !storageKey) return;

		          try {
		              storedLevel = window.localStorage[storageKey];
		          } catch (ignore) {}

		          // Fallback to cookies if local storage gives us nothing
		          if (typeof storedLevel === undefinedType) {
		              try {
		                  var cookie = window.document.cookie;
		                  var cookieName = encodeURIComponent(storageKey);
		                  var location = cookie.indexOf(cookieName + "=");
		                  if (location !== -1) {
		                      storedLevel = /^([^;]+)/.exec(
		                          cookie.slice(location + cookieName.length + 1)
		                      )[1];
		                  }
		              } catch (ignore) {}
		          }

		          // If the stored level is not valid, treat it as if nothing was stored.
		          if (self.levels[storedLevel] === undefined) {
		              storedLevel = undefined;
		          }

		          return storedLevel;
		      }

		      function clearPersistedLevel() {
		          if (typeof window === undefinedType || !storageKey) return;

		          // Use localStorage if available
		          try {
		              window.localStorage.removeItem(storageKey);
		          } catch (ignore) {}

		          // Use session cookie as fallback
		          try {
		              window.document.cookie =
		                encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
		          } catch (ignore) {}
		      }

		      function normalizeLevel(input) {
		          var level = input;
		          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
		              level = self.levels[level.toUpperCase()];
		          }
		          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
		              return level;
		          } else {
		              throw new TypeError("log.setLevel() called with invalid level: " + input);
		          }
		      }

		      /*
		       *
		       * Public logger API - see https://github.com/pimterry/loglevel for details
		       *
		       */

		      self.name = name;

		      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
		          "ERROR": 4, "SILENT": 5};

		      self.methodFactory = factory || defaultMethodFactory;

		      self.getLevel = function () {
		          if (userLevel != null) {
		            return userLevel;
		          } else if (defaultLevel != null) {
		            return defaultLevel;
		          } else {
		            return inheritedLevel;
		          }
		      };

		      self.setLevel = function (level, persist) {
		          userLevel = normalizeLevel(level);
		          if (persist !== false) {  // defaults to true
		              persistLevelIfPossible(userLevel);
		          }

		          // NOTE: in v2, this should call rebuild(), which updates children.
		          return replaceLoggingMethods.call(self);
		      };

		      self.setDefaultLevel = function (level) {
		          defaultLevel = normalizeLevel(level);
		          if (!getPersistedLevel()) {
		              self.setLevel(level, false);
		          }
		      };

		      self.resetLevel = function () {
		          userLevel = null;
		          clearPersistedLevel();
		          replaceLoggingMethods.call(self);
		      };

		      self.enableAll = function(persist) {
		          self.setLevel(self.levels.TRACE, persist);
		      };

		      self.disableAll = function(persist) {
		          self.setLevel(self.levels.SILENT, persist);
		      };

		      self.rebuild = function () {
		          if (defaultLogger !== self) {
		              inheritedLevel = normalizeLevel(defaultLogger.getLevel());
		          }
		          replaceLoggingMethods.call(self);

		          if (defaultLogger === self) {
		              for (var childName in _loggersByName) {
		                _loggersByName[childName].rebuild();
		              }
		          }
		      };

		      // Initialize all the internal levels.
		      inheritedLevel = normalizeLevel(
		          defaultLogger ? defaultLogger.getLevel() : "WARN"
		      );
		      var initialLevel = getPersistedLevel();
		      if (initialLevel != null) {
		          userLevel = normalizeLevel(initialLevel);
		      }
		      replaceLoggingMethods.call(self);
		    }

		    /*
		     *
		     * Top-level API
		     *
		     */

		    defaultLogger = new Logger();

		    defaultLogger.getLogger = function getLogger(name) {
		        if ((typeof name !== "symbol" && typeof name !== "string") || name === "") {
		            throw new TypeError("You must supply a name when creating a logger.");
		        }

		        var logger = _loggersByName[name];
		        if (!logger) {
		            logger = _loggersByName[name] = new Logger(
		                name,
		                defaultLogger.methodFactory
		            );
		        }
		        return logger;
		    };

		    // Grab the current global log variable in case of overwrite
		    var _log = (typeof window !== undefinedType) ? window.log : undefined;
		    defaultLogger.noConflict = function() {
		        if (typeof window !== undefinedType &&
		               window.log === defaultLogger) {
		            window.log = _log;
		        }

		        return defaultLogger;
		    };

		    defaultLogger.getLoggers = function getLoggers() {
		        return _loggersByName;
		    };

		    // ES6 default export, for compatibility
		    defaultLogger['default'] = defaultLogger;

		    return defaultLogger;
		})); 
	} (loglevel$1));
	return loglevel$1.exports;
}

var loglevelExports = requireLoglevel();
var f$1 = /*@__PURE__*/getDefaultExportFromCjs(loglevelExports);

const k=(e,t)=>s=>s(e,t),G=(e,t,s)=>o=>o(e,t,{append:false},s),x=()=>{const e=typeof process<"u"&&process.env?process.env:{},t=e.NODE_ENV==="test",s="VITEST"in e,o="JEST_WORKER_ID"in e,a="PLAYWRIGHT_TEST_BASE_URL"in e,r=e.CI==="true",i=e.TEST==="true"||e.IS_TEST==="true",c=typeof navigator<"u"&&navigator.webdriver===true,m=typeof navigator<"u"&&/playwright|puppeteer|webdriver|selenium|testcafe/i.test(navigator.userAgent);return t||s||o||a||r||i||c||m},n$1={A11yUi:{CSS_STYLE_CACHE:new Map,FEATURES:{},IS_TEST_ENVIRONMENT:x(),PERFORMANCE_MEASURES:new Map,STYLING_TASK_QUEUE:new Map,THEMES:new Map,THEME_FEATURES:{},showAverageTimes:()=>{const e={};for(const[s,o]of n$1.A11yUi.PERFORMANCE_MEASURES.entries())e[s]=[o.totalTime/o.count,o.count];const t=Object.entries(e).sort((s,o)=>o[1][0]-s[1][0]);return console.table(Object.fromEntries(t.map(([s,[o,a]])=>[s,{"avg (ms)":parseFloat(o.toFixed(2)),count:a}]))),e}}};let E=true,u$1=false;const K=/^[a-z][a-z0-9]{1,}(-[a-z0-9]+)?$/,B=e=>typeof e=="string"&&K.test(e),U=e=>{if(!B(e))throw new Error(`[Theming] The theme identifier "${typeof e=="string"?e:""}" (Type: ${typeof e}) is not valid. Please use only follow this pattern: /^[a-z][a-z0-9]{1,}(-[a-z0-9]+)?$/`)},b=e=>e.replace(/\/\*[\s\S]*?\*\//g,"").replace(/\s*([{},;])\s*/g,"$1").replace(/:\s+/g,":").replace(/\s+/g," ").replace(/;\}/g,"}").trim(),D=(e,t,s,o)=>p(e,t,s,o),p=(e,t,s,o)=>{o=o??{},o.append=o.append??false,U(e),E&&!u$1&&(u$1=true,f$1.warn(`[Theming] The theme process is locked. This means that the theme "${e}" should not be patched.

    import { register } from 'adopted-style-sheets';
    import { defineCustomElements } from '...';
    import { THEME } from '...';

    register(THEME, defineCustomElements)
    .then(() => {
        // run your app or website
    })
    .catch(console.warn);`));let a=n$1.A11yUi.THEMES.get(e);if(a||(a=new Map,n$1.A11yUi.THEMES.set(e,a)),o.append&&a.has(t)){const r=a.get(t);a.set(t,b(`${r}${s}`));}else a.set(t,b(s));},z=(e,t,s,o)=>g(e,t,s,o),g=(e,t,s,o)=>(U(e),typeof t=="object"&&t!==null&&Object.getOwnPropertyNames(t).forEach(a=>{const r=t[a],i=a.toLowerCase(),c=typeof o?.transformTagName=="function"&&!["GLOBAL","PROPERTIES"].includes(a)?o.transformTagName(i):a;typeof r=="string"&&r.length>0&&p(e,c.toUpperCase(),r,s);}),e),C=e=>{if(e instanceof HTMLElement){if(typeof e.dataset.theme=="string")return e;{let t=e.parentNode;for(;typeof ShadowRoot<"u"&&t instanceof ShadowRoot;)t=t.host;return C(t)}}else return null},M=(e={})=>e.themeEncroachCss==="false"||e.themeReset==="true"?false:{mode:e.themeEncroachCssMode==="after"||e.themeEncroachCssMode==="before"?e.themeEncroachCssMode:"before"},y=()=>typeof n$1.A11yUi.Theme=="object"&&n$1.A11yUi.Theme!==null&&typeof n$1.A11yUi.Theme.cache=="boolean"&&typeof n$1.A11yUi.Theme.encroachCss=="object"&&n$1.A11yUi.Theme.encroachCss!==null&&typeof n$1.A11yUi.Theme.encroachCss.mode=="string"&&typeof n$1.A11yUi.Theme.name=="string",Q=()=>!(typeof n$1.A11yUi.Theme=="object"&&n$1.A11yUi.Theme!==null)||n$1.A11yUi.Theme.name!=="default",w=e=>{if(y())return n$1.A11yUi.Theme;{const t={cache:true,encroachCss:M(),loglevel:"silent",mode:"csr",name:null},s=C(e);return s instanceof HTMLElement&&(t.cache=s.dataset.themeCache!=="false",t.encroachCss=M(s.dataset),t.loglevel=s.dataset.themeLoglevel==="debug"?s.dataset.themeLoglevel:"silent",t.mode=s.dataset.themeMode==="ssr"?s.dataset.themeMode:"csr",t.name=s.dataset.theme||null),t}},v=e=>w(e).name,R=()=>y()?n$1.A11yUi.Theme.name:null,W=(e,t)=>({cache:t.cache!==false,detect:t.detect==="auto"?"auto":"fixed",encroachCss:t.encroachCss===false?false:typeof t.encroachCss=="object"&&t.encroachCss!=null&&(t.encroachCss.mode==="after"||t.encroachCss.mode==="before")?t.encroachCss:{mode:"before"},loglevel:t.loglevel==="debug"?t.loglevel:"silent",mode:t.mode==="ssr"?t.mode:"csr",name:typeof t.name=="string"?t.name:e}),q=(e,t)=>{y()===false&&Q()&&typeof t=="object"&&t!==null&&(t=W(e,t),t.detect==="fixed"?(t.name===null&&typeof e=="string"&&(t.name=e),e===t.name&&(n$1.A11yUi.Theme=t,f$1.info(`[Theming] Theme "${e}" was set as default theme.`))):u$1||(u$1=true,f$1.warn("[Theming] The presetting of theme options is only relevant by using 'fixed' detection mode.")));},A=(...e)=>{const t={};for(const s of e)s&&Object.assign(t,s);return t},X=(e,t)=>{const s=n$1.A11yUi.FEATURES[e];if(s!==void 0)return s;const o=v(t??null)??R();if(o!==null){const a=n$1.A11yUi.THEME_FEATURES[o];if(a&&a[e]!==void 0)return a[e]}};let N=false;const se=(e,t,s={})=>{N||(N=true,E=false,typeof window<"u"&&(window.A11yUi=n$1.A11yUi)),typeof e=="function"?e=new Set([e]):Array.isArray(e)&&(e=new Set(e)),e instanceof Set&&e.forEach(a=>{typeof a=="function"&&a.length===1?q(a((r,i,c,m)=>(m&&(n$1.A11yUi.THEME_FEATURES[r]=A(n$1.A11yUi.THEME_FEATURES[r],m)),g(r,i,c,s))),{cache:s.theme?.cache,detect:s.theme?.detect,encroachCss:s.theme?.encroachCss,mode:s.theme?.mode,name:s.theme?.name}):f$1.error("[Theming] An attempt was made to load an incompatible theme.");}),E=true,s.features&&(n$1.A11yUi.FEATURES=A(n$1.A11yUi.FEATURES,s.features)),typeof t=="function"?t=new Set([t]):Array.isArray(t)&&(t=new Set(t));const o=[];return t.forEach(a=>{const r=a();r instanceof Promise&&o.push(r);}),Promise.all(o)};const _=new Set,L=new Map,oe=/--[^;]+/g,ae=/:/,ne=typeof MutationObserver<"u";let F=25,H=()=>{F=Math.min(25+Math.log2(n$1.A11yUi.STYLING_TASK_QUEUE.size+1)*20,250);};const re=(e,t)=>{let s=t.match(oe);if(Array.isArray(s)){s=s.filter(a=>ae.test(a));const o=document.createElement("style");o.innerHTML=`.${e} {${s.join(";")}}`,document.querySelector("head")?.appendChild(o);}_.add(e);},T=(e,t)=>{const s=n$1.A11yUi.THEMES.get(e);if(s instanceof Map){const o=s.get(t);if(o!==void 0)return o}return ""},ie=e=>{const t=e.firstChild;if(!(!(t instanceof HTMLStyleElement)||t.dataset.themingFallback!==void 0))for(const s of Array.from(e.childNodes))if(s instanceof HTMLStyleElement&&s.tagName==="STYLE"&&s.dataset.themingFallback===void 0)e.removeChild(s);else break},ce=(e,t)=>{try{if(n$1.A11yUi.Theme?.mode==="ssr")throw new Error("SSR");const s=t.filter(o=>typeof o=="string"&&o.length>0).map(o=>{let a=L.get(o);return a||(a=new CSSStyleSheet,a.replaceSync(o),L.set(o,a)),a});e.adoptedStyleSheets=s;}catch{for(let o=t.length-1;o>=0;o--){const a=t[o];if(typeof a!="string"||a.length===0)continue;const r=t.length-1-o,i=document.createElement("style");switch(i.dataset.themingFallback="",r){case 4:i.dataset.themingBaseA11y="";break;case 3:i.dataset.themingBaseGlobal="";break;case 2:i.dataset.themingBaseComponent="";break;case 1:i.dataset.themingCustomGlobal="";break;case 0:i.dataset.themingCustomComponent="";break;default:i.dataset.themingUnknown="";break}i.innerHTML=a,e.insertBefore(i,e.firstChild);}}},le=(e,t,s)=>{if(s===false||s?.mode!=="before"&&s?.mode!=="after")return;const o=Array.from(e.childNodes).filter(r=>r instanceof HTMLStyleElement&&r.tagName==="STYLE");let a;try{a=Array.from(e.adoptedStyleSheets);}catch{a=[];}if(!(o.length===0&&a.length===0))if(s.mode==="before"){const r=[...a.map(i=>Array.from(i.cssRules).map(c=>c.cssText).join("")),...o.map(i=>i.innerHTML)];t.unshift(...r);}else o.forEach(r=>t.push(r.innerHTML)),a.forEach(r=>t.push(Array.from(r.cssRules).map(i=>i.cssText).join("")));},me=(e,t,s)=>{const o=t.name||"default";let a;try{if(e.shadowRoot===null)throw new Error("ShadowRoot is null");a=e.shadowRoot;}catch{a=e;}const r=n$1.A11yUi.CSS_STYLE_CACHE.get(o)?.get(e.tagName);if(r)O(e,a,r,s);else {const i=T(o,"PROPERTIES"),c=T(o,"GLOBAL"),m=T(o,e.tagName);_.has(o)===false&&re(o,c);const d=[i,c,m];if(le(a,d,t.encroachCss),t.cache===true){let h=n$1.A11yUi.CSS_STYLE_CACHE.get(o);h||(h=new Map,n$1.A11yUi.CSS_STYLE_CACHE.set(o,h)),h.set(e.tagName,d);}O(e,a,d,s);}},O=(e,t,s,o)=>{const a=n$1.A11yUi.Theme?.loglevel==="debug",r=a?performance.now():0;if(ie(t),ce(t,s),Te(e),requestAnimationFrame(o),a){const i=performance.now()-r,c=n$1.A11yUi.PERFORMANCE_MEASURES.get(e.tagName);c?(c.count+=1,c.totalTime+=i):n$1.A11yUi.PERFORMANCE_MEASURES.set(e.tagName,{count:1,totalTime:i});}},I=e=>{const t=n$1.A11yUi.STYLING_TASK_QUEUE.get(e);if(t){const{resetCss:s,themeDetails:o}=t;me(e,o,s);}},he=100;let S=(e,t=0)=>{if(t>=he)return;const s=setTimeout(()=>{clearTimeout(s),e.classList.contains("hydrated")?I(e):S(e,t+1);},F);};const fe={attributes:true,attributeFilter:["class"],childList:false,subtree:false},ue={attributes:true,attributeFilter:[],childList:false,subtree:false},P=ne?new MutationObserver((e,t)=>{const s=[];for(const o of e){const a=o.target;a.classList.contains("hydrated")&&n$1.A11yUi.STYLING_TASK_QUEUE.has(a)&&(I(a),s.push(a));}for(const o of s)t.observe(o,ue);}):null;P&&(S=e=>P.observe(e,fe),H=()=>{});const $=new Map;let j=(e,t)=>{if(t){const a=$.get(t);if(a!==void 0)return a}const s=getComputedStyle(e).getPropertyValue("--theme-visibility-delay").trim();let o;if(s.endsWith("ms"))o=parseFloat(s);else if(s.endsWith("s"))o=parseFloat(s)*1e3;else {const a=parseFloat(s);o=isNaN(a)?0:a;}return t&&$.set(t,o),o};n$1.A11yUi.IS_TEST_ENVIRONMENT&&(j=()=>0);const Y=(e,t)=>{e.style.setProperty("visibility",t),e.dataset.themed="";},ye=(e,t)=>{const s=e.style.visibility||null,o=t.name||"default";n$1.A11yUi.STYLING_TASK_QUEUE.set(e,{resetCss:()=>{const a=j(e,o);a>0?setTimeout(()=>{Y(e,s);},a):Y(e,s);},themeDetails:t}),e.style.setProperty("visibility","hidden","important"),S(e);},Te=e=>{n$1.A11yUi.STYLING_TASK_QUEUE.delete(e),H();},de=(e,t)=>{ye(e,{...n$1.A11yUi.Theme,...t});};class Ee{Prefix;Key;Tag;createTheme=(t,s,o)=>G(t,s,o);createTranslation=(t,s)=>k(t,s);constructor(t,s,o){this.Prefix=t,this.Key=Object.getOwnPropertyNames(s),this.Tag=Object.getOwnPropertyNames(o);}}

var KeyEnum;
(function (KeyEnum) {
    KeyEnum[KeyEnum["action-done"] = 0] = "action-done";
    KeyEnum[KeyEnum["action-running"] = 1] = "action-running";
    KeyEnum[KeyEnum["avatar-alt"] = 2] = "avatar-alt";
    KeyEnum[KeyEnum["character-counter-current"] = 3] = "character-counter-current";
    KeyEnum[KeyEnum["character-counter-current-of-max"] = 4] = "character-counter-current-of-max";
    KeyEnum[KeyEnum["character-counter-current-of-max-aria"] = 5] = "character-counter-current-of-max-aria";
    KeyEnum[KeyEnum["character-counter-max-aria"] = 6] = "character-counter-max-aria";
    KeyEnum[KeyEnum["character-limit-exceeded"] = 7] = "character-limit-exceeded";
    KeyEnum[KeyEnum["character-limit-hint"] = 8] = "character-limit-hint";
    KeyEnum[KeyEnum["character-limit-remaining"] = 9] = "character-limit-remaining";
    KeyEnum[KeyEnum["clear-search"] = 10] = "clear-search";
    KeyEnum[KeyEnum["close"] = 11] = "close";
    KeyEnum[KeyEnum["close-alert"] = 12] = "close-alert";
    KeyEnum[KeyEnum["data-browse-text"] = 13] = "data-browse-text";
    KeyEnum[KeyEnum["delete-selection"] = 14] = "delete-selection";
    KeyEnum[KeyEnum["entries-per-site"] = 15] = "entries-per-site";
    KeyEnum[KeyEnum["error"] = 16] = "error";
    KeyEnum[KeyEnum["error-list"] = 17] = "error-list";
    KeyEnum[KeyEnum["error-list-message"] = 18] = "error-list-message";
    KeyEnum[KeyEnum["filename-text"] = 19] = "filename-text";
    KeyEnum[KeyEnum["form-description"] = 20] = "form-description";
    KeyEnum[KeyEnum["hide-password"] = 21] = "hide-password";
    KeyEnum[KeyEnum["info"] = 22] = "info";
    KeyEnum[KeyEnum["kolibri-logo"] = 23] = "kolibri-logo";
    KeyEnum[KeyEnum["live-value"] = 24] = "live-value";
    KeyEnum[KeyEnum["live-value-bounded"] = 25] = "live-value-bounded";
    KeyEnum[KeyEnum["message"] = 26] = "message";
    KeyEnum[KeyEnum["meter-state-critical"] = 27] = "meter-state-critical";
    KeyEnum[KeyEnum["meter-state-optimum"] = 28] = "meter-state-optimum";
    KeyEnum[KeyEnum["meter-state-suboptimal"] = 29] = "meter-state-suboptimal";
    KeyEnum[KeyEnum["nav-maximize"] = 30] = "nav-maximize";
    KeyEnum[KeyEnum["nav-minimize"] = 31] = "nav-minimize";
    KeyEnum[KeyEnum["new"] = 32] = "new";
    KeyEnum[KeyEnum["no-entries"] = 33] = "no-entries";
    KeyEnum[KeyEnum["no-results-message"] = 34] = "no-results-message";
    KeyEnum[KeyEnum["open-link-in-tab"] = 35] = "open-link-in-tab";
    KeyEnum[KeyEnum["page"] = 36] = "page";
    KeyEnum[KeyEnum["page-back"] = 37] = "page-back";
    KeyEnum[KeyEnum["page-first"] = 38] = "page-first";
    KeyEnum[KeyEnum["page-last"] = 39] = "page-last";
    KeyEnum[KeyEnum["page-next"] = 40] = "page-next";
    KeyEnum[KeyEnum["pagination"] = 41] = "pagination";
    KeyEnum[KeyEnum["pagination-position-bottom"] = 42] = "pagination-position-bottom";
    KeyEnum[KeyEnum["pagination-position-top"] = 43] = "pagination-position-top";
    KeyEnum[KeyEnum["readonly"] = 44] = "readonly";
    KeyEnum[KeyEnum["show-password"] = 45] = "show-password";
    KeyEnum[KeyEnum["sort"] = 46] = "sort";
    KeyEnum[KeyEnum["split-button-dropdown-label-open"] = 47] = "split-button-dropdown-label-open";
    KeyEnum[KeyEnum["success"] = 48] = "success";
    KeyEnum[KeyEnum["table-data-loading"] = 49] = "table-data-loading";
    KeyEnum[KeyEnum["table-data-loaded"] = 50] = "table-data-loaded";
    KeyEnum[KeyEnum["table-pagination-label"] = 51] = "table-pagination-label";
    KeyEnum[KeyEnum["table-selection"] = 52] = "table-selection";
    KeyEnum[KeyEnum["table-selection-all"] = 53] = "table-selection-all";
    KeyEnum[KeyEnum["table-selection-indeterminate"] = 54] = "table-selection-indeterminate";
    KeyEnum[KeyEnum["table-selection-none"] = 55] = "table-selection-none";
    KeyEnum[KeyEnum["table-settings"] = 56] = "table-settings";
    KeyEnum[KeyEnum["table-settings-apply"] = 57] = "table-settings-apply";
    KeyEnum[KeyEnum["table-settings-cancel"] = 58] = "table-settings-cancel";
    KeyEnum[KeyEnum["table-settings-column-hidable"] = 59] = "table-settings-column-hidable";
    KeyEnum[KeyEnum["table-settings-column-not-hidable"] = 60] = "table-settings-column-not-hidable";
    KeyEnum[KeyEnum["table-settings-column-width"] = 61] = "table-settings-column-width";
    KeyEnum[KeyEnum["table-settings-error-all-invisible"] = 62] = "table-settings-error-all-invisible";
    KeyEnum[KeyEnum["table-settings-move-down"] = 63] = "table-settings-move-down";
    KeyEnum[KeyEnum["table-settings-move-up"] = 64] = "table-settings-move-up";
    KeyEnum[KeyEnum["table-settings-not-move"] = 65] = "table-settings-not-move";
    KeyEnum[KeyEnum["table-sort-order"] = 66] = "table-sort-order";
    KeyEnum[KeyEnum["table-visible-range"] = 67] = "table-visible-range";
    KeyEnum[KeyEnum["toast-close-all"] = 68] = "toast-close-all";
    KeyEnum[KeyEnum["version"] = 69] = "version";
    KeyEnum[KeyEnum["warning"] = 70] = "warning";
})(KeyEnum || (KeyEnum = {}));

var TagEnum;
(function (TagEnum) {
    TagEnum[TagEnum["abbr"] = 0] = "abbr";
    TagEnum[TagEnum["accordion"] = 1] = "accordion";
    TagEnum[TagEnum["alert"] = 2] = "alert";
    TagEnum[TagEnum["avatar"] = 3] = "avatar";
    TagEnum[TagEnum["badge"] = 4] = "badge";
    TagEnum[TagEnum["breadcrumb"] = 5] = "breadcrumb";
    TagEnum[TagEnum["button"] = 6] = "button";
    TagEnum[TagEnum["button-link"] = 7] = "button-link";
    TagEnum[TagEnum["card"] = 8] = "card";
    TagEnum[TagEnum["combobox"] = 9] = "combobox";
    TagEnum[TagEnum["details"] = 10] = "details";
    TagEnum[TagEnum["dialog"] = 11] = "dialog";
    TagEnum[TagEnum["drawer"] = 12] = "drawer";
    TagEnum[TagEnum["form"] = 13] = "form";
    TagEnum[TagEnum["heading"] = 14] = "heading";
    TagEnum[TagEnum["icon"] = 15] = "icon";
    TagEnum[TagEnum["image"] = 16] = "image";
    TagEnum[TagEnum["input-checkbox"] = 17] = "input-checkbox";
    TagEnum[TagEnum["input-color"] = 18] = "input-color";
    TagEnum[TagEnum["input-date"] = 19] = "input-date";
    TagEnum[TagEnum["input-email"] = 20] = "input-email";
    TagEnum[TagEnum["input-file"] = 21] = "input-file";
    TagEnum[TagEnum["input-number"] = 22] = "input-number";
    TagEnum[TagEnum["input-password"] = 23] = "input-password";
    TagEnum[TagEnum["input-radio"] = 24] = "input-radio";
    TagEnum[TagEnum["input-range"] = 25] = "input-range";
    TagEnum[TagEnum["input-text"] = 26] = "input-text";
    TagEnum[TagEnum["kolibri"] = 27] = "kolibri";
    TagEnum[TagEnum["link"] = 28] = "link";
    TagEnum[TagEnum["link-button"] = 29] = "link-button";
    TagEnum[TagEnum["logo"] = 30] = "logo";
    TagEnum[TagEnum["meter"] = 31] = "meter";
    TagEnum[TagEnum["modal"] = 32] = "modal";
    TagEnum[TagEnum["nav"] = 33] = "nav";
    TagEnum[TagEnum["pagination"] = 34] = "pagination";
    TagEnum[TagEnum["popover-button"] = 35] = "popover-button";
    TagEnum[TagEnum["progress"] = 36] = "progress";
    TagEnum[TagEnum["quote"] = 37] = "quote";
    TagEnum[TagEnum["select"] = 38] = "select";
    TagEnum[TagEnum["single-select"] = 39] = "single-select";
    TagEnum[TagEnum["skip-nav"] = 40] = "skip-nav";
    TagEnum[TagEnum["spin"] = 41] = "spin";
    TagEnum[TagEnum["split-button"] = 42] = "split-button";
    TagEnum[TagEnum["symbol"] = 43] = "symbol";
    TagEnum[TagEnum["table"] = 44] = "table";
    TagEnum[TagEnum["table-stateful"] = 45] = "table-stateful";
    TagEnum[TagEnum["table-stateless"] = 46] = "table-stateless";
    TagEnum[TagEnum["tabs"] = 47] = "tabs";
    TagEnum[TagEnum["textarea"] = 48] = "textarea";
    TagEnum[TagEnum["toast-container"] = 49] = "toast-container";
    TagEnum[TagEnum["toolbar"] = 50] = "toolbar";
    TagEnum[TagEnum["tooltip"] = 51] = "tooltip";
    TagEnum[TagEnum["tree"] = 52] = "tree";
    TagEnum[TagEnum["tree-item"] = 53] = "tree-item";
})(TagEnum || (TagEnum = {}));

const getWindow = () => {
    if (typeof window !== 'undefined')
        return window;
    return {};
};
const getDocument = () => {
    const win = getWindow();
    if (win && typeof win.document !== 'undefined')
        return win.document;
    return {};
};
const MODES = ['development', 'production', 'test'];
let runtimeMode = 'production';
const setRuntimeMode = (mode) => {
    try {
        if (MODES.includes(mode)) {
            runtimeMode = mode;
        }
        else {
            throw new Error(`Invalid NODE_ENV value: ${mode}. Expected one of ${MODES.join(', ')}.`);
        }
    }
    catch (_a) {
        runtimeMode = 'production';
    }
};
const getInitialMode = () => {
    try {
        const nodeEnv = typeof process !== 'undefined' && process.env ? process.env['NODE_ENV'] : undefined;
        if (nodeEnv && MODES.includes(nodeEnv)) {
            return nodeEnv;
        }
    }
    catch (_a) {
    }
    return 'production';
};
setRuntimeMode(getInitialMode());
let EXPERIMENTAL_MODE = false;
let COLOR_CONTRAST_ANALYSIS = false;
const isDevMode = () => runtimeMode === 'development';
const isTestMode = () => runtimeMode === 'test';
const getExperimentalMode = () => EXPERIMENTAL_MODE === true;
const setExperimentalMode = (mode) => {
    EXPERIMENTAL_MODE = mode === true;
};
const getColorContrastAnalysis = () => COLOR_CONTRAST_ANALYSIS === true;
const setColorContrastAnalysis = (mode) => {
    COLOR_CONTRAST_ANALYSIS = mode === true;
};
const LOG_STYLE = 'color: white; background: #666; font-weight: bold; padding: .25em .5em; border-radius: 3px; border: 1px solid #000';
const mapToArray = (msg) => {
    return Array.isArray(msg) ? msg : [msg];
};
const getLogLabel = (label) => {
    return `%c${label}`;
};
const handleClassifier = (label, classifier) => {
    if (typeof classifier === 'string' && classifier.length > 0) {
        return `${getLogLabel(label)} | ${classifier}`;
    }
    else {
        return getLogLabel(label);
    }
};
const getShield = (label, options) => {
    return [handleClassifier(label, options === null || options === void 0 ? void 0 : options.classifier), `${LOG_STYLE};${(options === null || options === void 0 ? void 0 : options.overwriteStyle) || ''}`];
};
const isDevModeOrForceLog = (forceLog) => isDevMode() || forceLog === true;
class Logger {
    constructor(label) {
        this.label = label;
    }
    debug(msg, options) {
        if (isDevModeOrForceLog(options === null || options === void 0 ? void 0 : options.forceLog)) {
            console.debug(...getShield(this.label, options), ...mapToArray(msg));
        }
    }
    info(msg, options) {
        if (isDevModeOrForceLog(options === null || options === void 0 ? void 0 : options.forceLog)) {
            console.info(...getShield(this.label, options), ...mapToArray(msg));
        }
    }
    trace(msg, options) {
        if (isDevModeOrForceLog(options === null || options === void 0 ? void 0 : options.forceLog)) {
            console.trace(...getShield(this.label, options), ...mapToArray(msg));
        }
    }
    warn(msg, options) {
        if (isDevModeOrForceLog(options === null || options === void 0 ? void 0 : options.forceLog)) {
            console.warn(...getShield(this.label, options), ...mapToArray(msg));
        }
    }
    error(msg, options) {
        console.error(...getShield(this.label, options), ...mapToArray(msg));
    }
    throw(msg, options) {
        if (isDevModeOrForceLog(options === null || options === void 0 ? void 0 : options.forceLog)) {
            throw new Error(...getShield(this.label, options), ...mapToArray(msg));
        }
    }
}
const Log = new Logger('KoliBri');

const a11yCache = new Set();
const a11yHint = (msg, options) => {
    if (a11yCache.has(msg) === false || false) {
        a11yCache.add(msg);
        Log.debug([msg].concat([]), {
            classifier: `✋ a11y`,
            forceLog: false,
            overwriteStyle: '; background-color: #09f',
        });
    }
};
const deprecatedCache = new Set();
const deprecatedHint = (msg, options) => {
    if (deprecatedCache.has(msg) === false || false) {
        deprecatedCache.add(msg);
        Log.warn([msg].concat([]), {
            classifier: `🔥 deprecated`,
            forceLog: false,
            overwriteStyle: '; background-color: #f00',
        });
    }
};
const devCache = new Set();
const devHint = (msg, options) => {
    if (devCache.has(msg) === false || !!(options === null || options === void 0 ? void 0 : options.force)) {
        devCache.add(msg);
        Log.debug([msg].concat((options === null || options === void 0 ? void 0 : options.details) || []), {
            classifier: `💻 dev`,
            forceLog: !!(options === null || options === void 0 ? void 0 : options.force),
            overwriteStyle: '; background-color: #f09',
        });
    }
};
const devWarning = (msg, options) => {
    if (devCache.has(msg) === false || false) {
        devCache.add(msg);
        Log.warn([msg].concat([]), {
            classifier: `⚠️ dev`,
            forceLog: false,
            overwriteStyle: '; background-color: #f09',
        });
    }
};
const featureCache = new Set();
const featureHint = (msg, done = false, options) => {
    if (featureCache.has(msg) === false || false) {
        featureCache.add(msg);
        msg += done === true ? ' ✅' : '';
        Log.debug([msg].concat([]), {
            classifier: `🌟 feature`,
            forceLog: false,
            overwriteStyle: '; background-color: #309',
        });
    }
};
devHint(`We appreciate any feedback, comments, screenshots, or demo links of an application based on KoliBri (kolibri@itzbund.de). Thank you!`);
const uiUxCache = new Set();
const uiUxHint = (msg, options) => {
    if (uiUxCache.has(msg) === false || false) {
        uiUxCache.add(msg);
        Log.debug([msg].concat([]), {
            classifier: `📑 ui/ux`,
            forceLog: false,
            overwriteStyle: '; background-color: #060;',
        });
    }
};
const a11yHintDisabled = () => {
    a11yHint(`"Disabled" limits accessibility and visibility. From an accessibility perspective, we recommend using the readonly attribute instead of disabled.\n- https://uxdesign.cc/is-it-ok-to-grey-out-disabled-buttons-8afa74a0fae`);
};
const a11yHintLabelingLandmarks = (value) => {
    if (typeof value !== 'string' || value === '') {
        a11yHint(`Some structural elements, such as the nav tag, can be used multiple times on a webpage. To distinguish between similarly named structural elements, it is necessary to set an ARIA label.\n- https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/Navigation_Role#accessibility_concerns`);
    }
};
const uiUxHintMillerscheZahl = (className, length = 8) => {
    if (length > 7) {
        uiUxHint(`[${className}] Within navigation structures, it is recommended to use no more than 7 menu items.

Link:
- https://en.wikipedia.org/wiki/The_Magical_Number_Seven,_Plus_or_Minus_Two`);
    }
};

var n=.2126,r=.7152,t=.0722,e=1/12.92;function u(n){return Math.pow((n+.055)/1.055,2.4)}function a(a){var i=a[0]/255,c=a[1]/255,o=a[2]/255,s=i<=.03928?i*e:u(i),f=c<=.03928?c*e:u(c),l=o<=.03928?o*e:u(o);return s*n+f*r+l*t}function i(n){var r=255;8===(n=n.replace(/^#/,"")).length&&(r=parseInt(n.slice(6,8),16),n=n.substring(0,6)),4===n.length&&(r=parseInt(n.slice(3,4).repeat(2),16),n=n.substring(0,3)),3===n.length&&(n=n[0]+n[0]+n[1]+n[1]+n[2]+n[2]);var t=parseInt(n,16);return [t>>16,t>>8&255,255&t,r]}function c(n,r){return (Math.max(n,r)+.05)/(Math.min(n,r)+.05)}function o(n,r){return c(a(n),a(r))}function s(n,r){return o(i(n),i(r))}function f(n){return n>=7?"AAA":n>=4.5?"AA":n>=3?"AA Large":"Fail"}

var colorName;
var hasRequiredColorName;

function requireColorName () {
	if (hasRequiredColorName) return colorName;
	hasRequiredColorName = 1;

	colorName = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};
	return colorName;
}

/**
 * @module color-parse
 */

var colorParse;
var hasRequiredColorParse;

function requireColorParse () {
	if (hasRequiredColorParse) return colorParse;
	hasRequiredColorParse = 1;

	var names = requireColorName();

	colorParse = parse;

	/**
	 * Base hues
	 * http://dev.w3.org/csswg/css-color/#typedef-named-hue
	 */
	//FIXME: use external hue detector
	var baseHues = {
		red: 0,
		orange: 60,
		yellow: 120,
		green: 180,
		blue: 240,
		purple: 300
	};

	/**
	 * Parse color from the string passed
	 *
	 * @return {Object} A space indicator `space`, an array `values` and `alpha`
	 */
	function parse(cstr) {
		var m, parts = [], alpha = 1, space;

		if (typeof cstr === 'string') {
			cstr = cstr.toLowerCase();

			//keyword
			if (names[cstr]) {
				parts = names[cstr].slice();
				space = 'rgb';
			}

			//reserved words
			else if (cstr === 'transparent') {
				alpha = 0;
				space = 'rgb';
				parts = [0, 0, 0];
			}

			//hex
			else if (/^#[A-Fa-f0-9]+$/.test(cstr)) {
				var base = cstr.slice(1);
				var size = base.length;
				var isShort = size <= 4;
				alpha = 1;

				if (isShort) {
					parts = [
						parseInt(base[0] + base[0], 16),
						parseInt(base[1] + base[1], 16),
						parseInt(base[2] + base[2], 16)
					];
					if (size === 4) {
						alpha = parseInt(base[3] + base[3], 16) / 255;
					}
				}
				else {
					parts = [
						parseInt(base[0] + base[1], 16),
						parseInt(base[2] + base[3], 16),
						parseInt(base[4] + base[5], 16)
					];
					if (size === 8) {
						alpha = parseInt(base[6] + base[7], 16) / 255;
					}
				}

				if (!parts[0]) parts[0] = 0;
				if (!parts[1]) parts[1] = 0;
				if (!parts[2]) parts[2] = 0;

				space = 'rgb';
			}

			//color space
			else if (m = /^((?:rgb|hs[lvb]|hwb|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms)a?)\s*\(([^\)]*)\)/.exec(cstr)) {
				var name = m[1];
				var isRGB = name === 'rgb';
				var base = name.replace(/a$/, '');
				space = base;
				var size = base === 'cmyk' ? 4 : base === 'gray' ? 1 : 3;
				parts = m[2].trim()
					.split(/\s*[,\/]\s*|\s+/)
					.map(function (x, i) {
						//<percentage>
						if (/%$/.test(x)) {
							//alpha
							if (i === size) return parseFloat(x) / 100
							//rgb
							if (base === 'rgb') return parseFloat(x) * 255 / 100
							return parseFloat(x)
						}
						//hue
						else if (base[i] === 'h') {
							//<deg>
							if (/deg$/.test(x)) {
								return parseFloat(x)
							}
							//<base-hue>
							else if (baseHues[x] !== undefined) {
								return baseHues[x]
							}
						}
						return parseFloat(x)
					});

				if (name === base) parts.push(1);
				alpha = (isRGB) ? 1 : (parts[size] === undefined) ? 1 : parts[size];
				parts = parts.slice(0, size);
			}

			//named channels case
			else if (cstr.length > 10 && /[0-9](?:\s|\/)/.test(cstr)) {
				parts = cstr.match(/([0-9]+)/g).map(function (value) {
					return parseFloat(value)
				});

				space = cstr.match(/([a-z])/ig).join('').toLowerCase();
			}
		}

		//numeric case
		else if (!isNaN(cstr)) {
			space = 'rgb';
			parts = [cstr >>> 16, (cstr & 0x00ff00) >>> 8, cstr & 0x0000ff];
		}

		//array-like
		else if (Array.isArray(cstr) || cstr.length) {
			parts = [cstr[0], cstr[1], cstr[2]];
			space = 'rgb';
			alpha = cstr.length === 4 ? cstr[3] : 1;
		}

		//object case - detects css cases of rgb and hsl
		else if (cstr instanceof Object) {
			if (cstr.r != null || cstr.red != null || cstr.R != null) {
				space = 'rgb';
				parts = [
					cstr.r || cstr.red || cstr.R || 0,
					cstr.g || cstr.green || cstr.G || 0,
					cstr.b || cstr.blue || cstr.B || 0
				];
			}
			else {
				space = 'hsl';
				parts = [
					cstr.h || cstr.hue || cstr.H || 0,
					cstr.s || cstr.saturation || cstr.S || 0,
					cstr.l || cstr.lightness || cstr.L || cstr.b || cstr.brightness
				];
			}

			alpha = cstr.a || cstr.alpha || cstr.opacity || 1;

			if (cstr.opacity != null) alpha /= 100;
		}

		return {
			space: space,
			values: parts,
			alpha: alpha
		}
	}
	return colorParse;
}

var colorParseExports = requireColorParse();
var parse = /*@__PURE__*/getDefaultExportFromCjs(colorParseExports);

/**
 * RGB space.
 *
 * @module  color-space/rgb
 */
const rgb = {
	min: [0, 0, 0],
	max: [255, 255, 255]};

/**
 * @module color-space/hsl
 */

var hsl = {
	name: 'hsl',
	min: [0, 0, 0],
	max: [360, 100, 100],
	channel: ['hue', 'saturation', 'lightness'],
	alias: ['HSL'],

	rgb: function (hsl) {
		var h = hsl[0] / 360, s = hsl[1] / 100, l = hsl[2] / 100, t1, t2, t3, rgb, val, i = 0;

		if (s === 0) return val = l * 255, [val, val, val];

		t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
		t1 = 2 * l - t2;

		rgb = [0, 0, 0];
		for (; i < 3;) {
			t3 = h + 1 / 3 * - (i - 1);
			t3 < 0 ? t3++ : t3 > 1 && t3--;
			val = 6 * t3 < 1 ? t1 + (t2 - t1) * 6 * t3 :
				2 * t3 < 1 ? t2 :
					3 * t3 < 2 ? t1 + (t2 - t1) * (2 / 3 - t3) * 6 :
						t1;
			rgb[i++] = val * 255;
		}

		return rgb;
	}
};


//extend rgb
rgb.hsl = function (rgb) {
	var r = rgb[0] / 255,
		g = rgb[1] / 255,
		b = rgb[2] / 255,
		min = Math.min(r, g, b),
		max = Math.max(r, g, b),
		delta = max - min,
		h, s, l;

	if (max === min) {
		h = 0;
	}
	else if (r === max) {
		h = (g - b) / delta;
	}
	else if (g === max) {
		h = 2 + (b - r) / delta;
	}
	else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	//FIXME h is possibly undefined
	//@ts-ignore
	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	}
	else if (l <= 0.5) {
		s = delta / (max + min);
	}
	else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

var rgbaConvert = {exports: {}};

var hasRequiredRgbaConvert;

function requireRgbaConvert () {
	if (hasRequiredRgbaConvert) return rgbaConvert.exports;
	hasRequiredRgbaConvert = 1;
	rgbaConvert.exports     = arr;
	rgbaConvert.exports.arr = arr;
	rgbaConvert.exports.obj = obj;
	rgbaConvert.exports.css = css;
	rgbaConvert.exports.hex = hex;
	rgbaConvert.exports.num = num;

	function arr(data) {
	  var a = parse(data);
	  if (a.length == 3) {
	    return a.concat(255)
	  } else {
	    a[3] = Math.round(a[3]);
	    return a
	  }
	}

	function obj(data) {
	  var a = parse(data);
	  return {
	    r: a[0],
	    g: a[1],
	    b: a[2],
	    a: a.length == 3
	      ? 255
	      : Math.round(a[3])
	  }
	}

	function css(data) {
	  var a = parse(data);
	  if (a.length == 3) a.push(255);

	  return a[3] == 255
	    ? 'rgb(' + a[0] + ', ' + a[1] + ', ' + a[2] + ')'
	    : a[3] == 0
	      ? 'rgba(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', 0)'
	      : 'rgba(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + String(a[3] / 255).substr(1) + ')'
	}

	function hex(data) {
	  var a = parse(data);
	  if (a.length == 3) a.push(255);
	  var opaque = a[3] == 255;
	  var r = num2hex(a[0]);
	  var g = num2hex(a[1]);
	  var b = num2hex(a[2]);
	  var a = num2hex(Math.round(a[3]));
	  var is = isshort(r, g, b, a);
	  if (opaque) {
	    return is
	      ? '#' + r.charAt(0) + g.charAt(0) + b.charAt(0)
	      : '#' + r + g + b
	  }
	  return is
	    ? '#' + r.charAt(0) + g.charAt(0) + b.charAt(0) + a.charAt(0)
	    : '#' + r + g + b + a
	}

	function num(data) {
	  var a = parse(data);
	  if (a.length == 3) a.push(255);
	  else a[3] = Math.round(a[3]);
	  return ((a[3] << 24) >>> 0 | a[0] << 16 | a[1] << 8 | a[2]) >>> 0
	}

	function parse(data) {
	  if (typeof data == 'string') {
	    data = data.toLowerCase();
	    return name(data)
	      || hex3(data)
	      || hex6(data)
	      || rgb(data)
	      || rgba(data)
	      || [0, 0, 0, 255]
	  }
	  return object(data)
	    || array(data)
	    || number(data)
	    || [0, 0, 0, 255]
	}

	function num2hex(num) {
	  var s = num.toString(16);
	  return s.length == 1
	    ? '0' + s
	    : s
	}

	function isshort(r, g, b, a) {
	  var h = ['ff', '00', '11', '22', '33', '44', '55', '66',
	           '77', '88', '99', 'aa', 'bb', 'cc', 'dd', 'ee'];
	  return h.indexOf(r) != -1
	    && h.indexOf(g) != -1
	    && h.indexOf(b) != -1
	    && h.indexOf(a) != -1
	}

	function name(str) {
	  if (str == 'red')     return [255, 0, 0]
	  if (str == 'green')   return [0, 255, 0]
	  if (str == 'blue')    return [0, 0, 255]
	  if (str == 'black')   return [0, 0, 0]
	  if (str == 'white')   return [255, 255, 255]
	  if (str == 'cyan')    return [0, 255, 255]
	  if (str == 'gray')    return [128, 128, 128]
	  if (str == 'grey')    return [128, 128, 128]
	  if (str == 'magenta') return [255, 0, 255]
	  // ok, not the real css `pink` but my personal `magenta` alias
	  // `pink` is simpler than `fuchsia`, whatever...
	  if (str == 'pink')    return [255, 0, 255]
	  if (str == 'yellow')  return [255, 255, 0]
	}

	function hex2num(str) {
	  return str.length == 1
	    ? parseInt(str + str, 16)
	    : parseInt(str, 16)
	}

	function hex3(str) {
	  var s = str.replace(/^#/,'');
	  var l = s.length;
	  if (l == 3 || l == 4) {
	    var r = hex2num(s[0]);
	    var g = hex2num(s[1]);
	    var b = hex2num(s[2]);
	    var a = l == 3
	      ? 255
	      : hex2num(s[3]);

	    if (isNaN(r) || isNaN(g) || isNaN(b) || isNaN(a)) return

	    return [r, g, b, a]
	  }
	}

	function hex6(str) {
	  var s = str.replace(/^#/,'');
	  var l = s.length;
	  if (l == 6 || l == 8) {
	    var r = hex2num(s.slice(0, 2));
	    var g = hex2num(s.slice(2, 4));
	    var b = hex2num(s.slice(4, 6));
	    var a = l == 6
	      ? 255
	      : hex2num(s.slice(6, 8));

	    if (isNaN(r) || isNaN(g) || isNaN(b) || isNaN(a)) return

	    return [r, g, b, a]
	  }
	}

	function getnum(val, integer) {
	  if (typeof val != 'number') return -1
	  if (integer === true && Math.floor(val) !== val) return -1
	  return val >= 0 && val <= 255
	    ? val
	    : -1
	}

	function object(obj) {
	  if (Object.prototype.toString.call(obj) === '[object Object]'
	    && Object.getPrototypeOf(obj) === Object.getPrototypeOf({})) {
	    var r = getnum(obj.r != undefined ? obj.r : obj.red   != undefined ? obj.red   : 0,   true);
	    var g = getnum(obj.g != undefined ? obj.g : obj.green != undefined ? obj.green : 0,   true);
	    var b = getnum(obj.b != undefined ? obj.b : obj.blue  != undefined ? obj.blue  : 0,   true);
	    var a = getnum(obj.a != undefined ? obj.a : obj.alpha != undefined ? obj.alpha : 255, true);
	    if (r != -1 && g != -1 && b != -1 && a != -1) {
	      return [r, g, b, a]
	    }
	  }
	}

	function array(arr) {
	  if (Array.isArray(arr) && (arr.length == 3 || arr.length == 4)) {
	    var r = getnum(arr[0],   true);
	    var g = getnum(arr[1],   true);
	    var b = getnum(arr[2],   true);
	    var a = getnum(arr[3] != undefined ? arr[3] : 255, true);
	    if (r != -1 && g != -1 && b != -1 && a != -1) {
	      return [r, g, b, a]
	    }
	  }
	}

	function number(num) {
	  if (typeof num == 'number' && Math.floor(num) == num && num <= 4294967295 && num >= 0) {
	    var a = num >> 24 & 255;
	    var r = num >> 16 & 255;
	    var g = num >> 8  & 255;
	    var b = num & 255;
	    return [r, g, b, a]
	  }
	}

	function rgb(str) {
	  if (str.substr(0, 4) == 'rgb(') {
	    str = str.match(/^rgb\(([^)]+)\)/)[1];
	    var t = str.split(/ *, */).map(Number);
	    var r = getnum(t[0], true);
	    var g = getnum(t[1], true);
	    var b = getnum(t[2], true);
	    if (r != -1 && g != -1 && b != -1) {
	      return [r, g, b, 255]
	    }
	  }
	}

	function rgba(str) {
	  if (str.substr(0, 5) == 'rgba(') {
	    str = str.match(/^rgba\(([^)]+)\)/)[1];
	    var t = str.split(/ *, */).map(Number);
	    var r = getnum(t[0], true);
	    var g = getnum(t[1], true);
	    var b = getnum(t[2], true);
	    var a = getnum(t[3] * 255);
	    if (r != -1 && g != -1 && b != -1 && a != -1) {
	      return [r, g, b, a]
	    }
	  }
	}
	return rgbaConvert.exports;
}

var rgbaConvertExports = requireRgbaConvert();
var rgba = /*@__PURE__*/getDefaultExportFromCjs(rgbaConvertExports);

const OBJECT_OBJECT = /\[object Object\]/;
const objectObjectHandler = (value, cb) => {
    if (typeof value === 'string' && OBJECT_OBJECT.test(value)) {
        return;
    }
    cb();
};
const emptyStringByArrayHandler = (value, cb) => {
    if (typeof value === 'string' && value === '') {
        return;
    }
    cb();
};
const setEventTarget = (event, target) => {
    if (getExperimentalMode()) {
        Log.debug([event, target]);
        Log.debug(`↑ We propagate the (submit) event to this target.`);
    }
    Object.defineProperty(event, 'target', {
        value: target,
        writable: false,
    });
};
const patchState = (component) => {
    var _a, _b, _c;
    (_a = component.nextHooks) === null || _a === void 0 ? void 0 : _a.forEach((hooks, key) => {
        var _a;
        const beforePatch = hooks.get('beforePatch');
        if (typeof beforePatch === 'function') {
            beforePatch((_a = component.nextState) === null || _a === void 0 ? void 0 : _a.get(key), component.nextState, component, key);
        }
    });
    if (((_b = component.nextState) === null || _b === void 0 ? void 0 : _b.size) > 0) {
        component.state = Object.assign(Object.assign({}, component.state), Object.fromEntries(component.nextState));
        delete component.nextState;
        (_c = component.nextHooks) === null || _c === void 0 ? void 0 : _c.forEach((hooks, key) => {
            const afterPatch = hooks.get('afterPatch');
            if (typeof afterPatch === 'function') {
                afterPatch(component.state[key], component.state, component, key);
            }
        });
    }
    delete component.nextHooks;
};
const setState = (component, propName, value, hooks = {}) => {
    var _a, _b;
    if (component.nextHooks === undefined) {
        component.nextHooks = new Map();
    }
    if (component.nextState === undefined) {
        component.nextState = new Map();
    }
    const nextHooks = component.nextHooks.get(propName);
    if (nextHooks instanceof Map === false) {
        component.nextHooks.set(propName, new Map());
    }
    if (typeof hooks.afterPatch === 'function') {
        (_a = component.nextHooks.get(propName)) === null || _a === void 0 ? void 0 : _a.set('afterPatch', hooks.afterPatch);
    }
    if (typeof hooks.beforePatch === 'function') {
        (_b = component.nextHooks.get(propName)) === null || _b === void 0 ? void 0 : _b.set('beforePatch', hooks.beforePatch);
    }
    component.nextState.set(propName, value);
    patchState(component);
};
const logWarn = (component, propName, value, requiredGeneric) => {
    devHint(`[${component.constructor.name}] The property value: (${value}) for '${propName}' is not valid. Allowed values are: ${Array.from(requiredGeneric).join(', ')}`);
};
function watchValidator(component, propName, validationFunction, requiredGeneric, value, options = {}) {
    if (validationFunction(value)) {
        setState(component, propName, value, options.hooks);
    }
    else if (value === undefined && options.required !== true && validationFunction(options.defaultValue)) {
        setState(component, propName, options.defaultValue, options.hooks);
    }
    else {
        if (!options.required) {
            requiredGeneric.add(null);
        }
        logWarn(component, propName, value, requiredGeneric);
    }
}
const watchBoolean = (component, propName, value, options) => {
    watchValidator(component, propName, (value) => typeof value === 'boolean', new Set(['Boolean {true, false}']), value, options);
};
const watchString = (component, propName, value, options = {}) => {
    const minLength = typeof options.minLength === 'number' ? options === null || options === void 0 ? void 0 : options.minLength : 0;
    watchValidator(component, propName, (value) => typeof value === 'string' && value.length >= minLength && (typeof (options === null || options === void 0 ? void 0 : options.maxLength) === 'undefined' || value.length <= options.maxLength), new Set([`String`]), value, options);
};
const watchNumber = (component, propName, value, options) => {
    watchValidator(component, propName, (value) => typeof value === 'number' &&
        (typeof (options === null || options === void 0 ? void 0 : options.min) === 'undefined' || (typeof (options === null || options === void 0 ? void 0 : options.min) === 'number' && value >= options.min)) &&
        (typeof (options === null || options === void 0 ? void 0 : options.max) === 'undefined' || (typeof (options === null || options === void 0 ? void 0 : options.max) === 'number' && value <= options.max)), new Set(['Number']), value, options);
};
const watchJsonArrayString = (component, propName, itemValidation, value, arrayValidation = (items) => items === items, options = {}) => {
    emptyStringByArrayHandler(value, () => {
        objectObjectHandler(value, () => {
            if (typeof value === 'undefined') {
                value = [];
            }
            try {
                try {
                    value = parseJson(value);
                }
                catch (_a) {
                }
                if (Array.isArray(value)) {
                    const invalid = value.find((item) => !itemValidation(item));
                    if (invalid === undefined && arrayValidation(value)) {
                        setState(component, propName, value, options.hooks);
                    }
                    else {
                        objectObjectHandler(invalid, () => {
                            Log.debug(invalid);
                            throw new Error(`↑ The schema for the property (_options) is not valid. The value will not be changed.`);
                        });
                    }
                }
                else {
                    objectObjectHandler(value, () => {
                        Log.debug(value);
                        throw new Error(`↑ The schema for the property (_options) is not valid. The value will not be changed.`);
                    });
                }
            }
            catch (error) {
                Log.debug(error);
            }
        });
    });
};
const stringifyJson = (value) => {
    try {
        return JSON.stringify(value).replace(/"/g, "'");
    }
    catch (_a) {
        Log.warn(['stringifyJson', value]);
        Log.error(`↑ The JSON could not be converted to a string. A stringifiable JSON is expected.`);
        throw new Error();
    }
};
const JSON_CHARS = /^[{[]/;
const parseJson = (value) => {
    if (typeof value === 'string') {
        try {
            return JSON.parse(value);
        }
        catch (_a) {
            if (JSON_CHARS.test(value)) {
                try {
                    return JSON.parse(value.replace(/'/g, '"'));
                }
                catch (_b) {
                    Log.warn(['parseJson', value]);
                    Log.error(`↑ The JSON string could not be parsed. Make sure that single quotes in the text are escaped (&#8216;).`);
                }
            }
        }
    }
    throw new Error();
};
const mapBoolean2String = (value) => {
    return typeof value === 'boolean' ? (value === true ? 'true' : 'false') : undefined;
};
const mapStringOrBoolean2String = (value) => {
    return typeof value === 'string' ? value : mapBoolean2String(value);
};
const traverseShadowDom = (rootNode, onNode) => {
    if (!rootNode) {
        return;
    }
    const visited = new Set();
    const queue = [rootNode];
    let index = 0;
    while (index < queue.length) {
        const current = queue[index++];
        if (visited.has(current)) {
            continue;
        }
        visited.add(current);
        if (onNode(current)) {
            return;
        }
        const children = Array.from(current.children || []);
        for (let i = 0; i < children.length; i++) {
            queue.push(children[i]);
        }
        if (current instanceof HTMLElement && current.shadowRoot) {
            queue.push(current.shadowRoot);
        }
        if (current instanceof HTMLSlotElement) {
            const assigned = current.assignedNodes({ flatten: true });
            for (let i = 0; i < assigned.length; i++) {
                if (assigned[i] instanceof Element) {
                    queue.push(assigned[i]);
                }
            }
        }
    }
};
const querySelectorShadow = (selector, rootNode) => {
    let result = null;
    traverseShadowDom(rootNode, (current) => {
        if (current instanceof Element && current.matches(selector)) {
            result = current;
            return true;
        }
        return false;
    });
    return result;
};
const querySelectorAllShadow = (selector, rootNode) => {
    const results = [];
    traverseShadowDom(rootNode, (current) => {
        if (current instanceof Element && current.matches(selector)) {
            results.push(current);
        }
        return false;
    });
    return results;
};
const koliBriQuerySelector = (selector, node) => querySelectorShadow(selector, node || getDocument());
const koliBriQuerySelectorAll = (selector, node) => querySelectorAllShadow(selector, node || getDocument());
let DEFAULT_COLOR_CONTRAST = null;
const getDefaultColorContrast = () => {
    DEFAULT_COLOR_CONTRAST = DEFAULT_COLOR_CONTRAST || {
        backgroundColor: '#00000000',
        color: '#00000000',
        domNode: getDocument().body,
        level: 'Fail',
        score: 1,
    };
    return DEFAULT_COLOR_CONTRAST;
};
const TRANSPARENT_REGEXP = /(\d+, ){3}0\)/;
const koliBriA11yColorContrast = (domNode, a11yColorContrast = getDefaultColorContrast()) => {
    const computedStyle = getComputedStyle(domNode);
    const hexBG = TRANSPARENT_REGEXP.test(computedStyle.backgroundColor) ? a11yColorContrast.backgroundColor : rgba.hex(computedStyle.backgroundColor);
    const hexC = TRANSPARENT_REGEXP.test(computedStyle.color) ? a11yColorContrast.color : rgba.hex(computedStyle.color);
    const diff = s(hexBG, hexC);
    const contrast = {
        backgroundColor: hexBG,
        color: hexC,
        domNode: domNode,
        level: f(diff),
        score: diff,
    };
    if (diff < 4.5) {
        Log.error([
            'Color-Contrast-Error',
            {
                backgroundColor: contrast.backgroundColor,
                color: contrast.color,
                level: contrast.level,
                score: contrast.score,
            },
            contrast.domNode,
        ]);
    }
    return contrast;
};
const koliBriQuerySelectorColors = (selector, a11yColorContrast = getDefaultColorContrast()) => {
    if (a11yColorContrast.domNode instanceof HTMLElement) {
        a11yColorContrast = koliBriA11yColorContrast(a11yColorContrast.domNode, a11yColorContrast);
    }
    const selectedNode = a11yColorContrast.domNode.querySelector(selector);
    if (selectedNode === null) {
        const nodeList = a11yColorContrast.domNode.querySelectorAll('[class="hydrated"]');
        for (let i = 0; i < nodeList.length; i++) {
            a11yColorContrast.domNode = nodeList[i];
            a11yColorContrast = koliBriQuerySelectorColors(selector, a11yColorContrast);
            if (a11yColorContrast.domNode !== null) {
                break;
            }
        }
        return a11yColorContrast;
    }
    else {
        return koliBriA11yColorContrast(selectedNode, a11yColorContrast);
    }
};
class KoliBriUtils {
    static queryHtmlElementColors(targetNode, a11yColorContrast, recursion = false, log = true) {
        let returnValue = null;
        if (recursion === true || KoliBriUtils.executionLock === false) {
            if (recursion === false) {
                KoliBriUtils.cache.clear();
                KoliBriUtils.cache.set(a11yColorContrast.domNode, a11yColorContrast);
                KoliBriUtils.executionLock = true;
                if (log === true) {
                    Log.debug(`[KoliBriUtils] Color contrast analysis started...`);
                }
            }
            if (targetNode === a11yColorContrast.domNode) {
                returnValue = a11yColorContrast;
            }
            else {
                const children = new Set();
                if (a11yColorContrast.domNode.shadowRoot) {
                    const shadowChildren = a11yColorContrast.domNode.shadowRoot.children;
                    for (let i = 0; i < shadowChildren.length; i++) {
                        children.add(shadowChildren[i]);
                    }
                }
                const slotElement = a11yColorContrast.domNode;
                if (typeof slotElement.assignedNodes === 'function') {
                    const slotChildren = slotElement.assignedNodes();
                    for (let i = 0; i < slotChildren.length; i++) {
                        if (slotChildren[i] instanceof HTMLElement) {
                            children.add(slotChildren[i]);
                        }
                    }
                }
                const domChildren = a11yColorContrast.domNode.children;
                for (let i = 0; i < domChildren.length; i++) {
                    children.add(domChildren[i]);
                }
                const arrayChildren = Array.from(children);
                for (let i = 0; i < arrayChildren.length; i++) {
                    let colorContrast = KoliBriUtils.cache.get(arrayChildren[i]);
                    if (colorContrast === undefined) {
                        colorContrast = koliBriA11yColorContrast(arrayChildren[i], a11yColorContrast);
                    }
                    KoliBriUtils.cache.set(arrayChildren[i], colorContrast);
                    const colors = KoliBriUtils.queryHtmlElementColors(targetNode, colorContrast, true, false);
                    if (colors !== null) {
                        returnValue = colors;
                        break;
                    }
                }
            }
        }
        else {
            Log.debug(`[KoliBriUtils] Call aborted because a color contrast analysis is currently being executed.`);
        }
        if (recursion === false) {
            if (log === true) {
                Log.debug(`[KoliBriUtils] Color contrast analysis finished (${KoliBriUtils.cache.size} DOM elements are analysed).`);
            }
            KoliBriUtils.executionLock = false;
            KoliBriUtils.cache.clear();
        }
        return returnValue;
    }
}
KoliBriUtils.executionLock = false;
KoliBriUtils.cache = new Map();
class KoliBriDevHelper {
}
KoliBriDevHelper.getCssStyle = T;
KoliBriDevHelper.patchTheme = z;
KoliBriDevHelper.patchThemeTag = D;
KoliBriDevHelper.querySelector = koliBriQuerySelector;
KoliBriDevHelper.querySelectorAll = koliBriQuerySelectorAll;
KoliBriDevHelper.stringifyJson = stringifyJson;

const isObject = (value) => typeof value === 'object' && value !== null;
const isString = (value, minLength = 0) => typeof value === 'string' && value.length >= minLength;
const isStyle = (style) => {
    if (typeof style === 'object' && style !== null) {
        for (const property in style) {
            if (isString(property, 1) === false) {
                return false;
            }
        }
    }
    else {
        return isString(style, 1);
    }
    return true;
};
const STATE_CHANGE_EVENT = new Event('StateChange');

export { KoliBriUtils as $, getDocument as A, setExperimentalMode as B, setColorContrastAnalysis as C, getWindow as D, Ee as E, isTestMode as F, devWarning as G, isObject as H, isStyle as I, watchJsonArrayString as J, KeyEnum as K, Log as L, uiUxHintMillerscheZahl as M, getExperimentalMode as N, watchNumber as O, emptyStringByArrayHandler as P, koliBriQuerySelector as Q, R, mapStringOrBoolean2String as S, TagEnum as T, mapBoolean2String as U, STATE_CHANGE_EVENT as V, isDevMode as W, X, koliBriA11yColorContrast as Y, koliBriQuerySelectorAll as Z, koliBriQuerySelectorColors as _, KoliBriDevHelper as a, stringifyJson as a0, getColorContrastAnalysis as a1, watchValidator as b, a11yHintLabelingLandmarks as c, de as d, watchBoolean as e, featureHint as f, watchString as g, deprecatedHint as h, isString as i, devHint as j, a11yHint as k, parse as l, hsl as m, rgba as n, objectObjectHandler as o, parseJson as p, s as q, rgb as r, setState as s, setEventTarget as t, setRuntimeMode as u, se as v, w, getDefaultExportFromCjs as x, a11yHintDisabled as y, uiUxHint as z };
//# sourceMappingURL=common-D-vggmh2.js.map

//# sourceMappingURL=common-D-vggmh2.js.map